import {
  ValidationComposite,
  ValidationBuilder as Builder,
} from "../../../../../validation/validators";

export const makeValidateAddSmartcardDetailsValidation =
  (): ValidationComposite =>
    ValidationComposite.build([
      ...Builder.field("smartcardName").required().build(),
      ...Builder.field("smartcardLocation").required().build(),
      ...Builder.field("companyNumber").required().build(),
    ]);
